import { request } from 'shared/lib/request';

export const fetchWaibiAccessToken = (refreshToken) => {
  const query = refreshToken ? `?refreshToken=${refreshToken}` : '';

  return request.get(`/waibi/access_token${query}`);
};
